module.exports = __webpack_public_path__ + "static/img/huaishuItem2.a8e5f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuItem2.png
// module id = LNc6
// module chunks = 0